// src/modules/purityAnalyzer/utils/debounce.js
// Minimal debounce (no lodash dependency in this project).

export default function debounce(fn, wait = 300) {
  let timer = null;
  const debounced = (...args) => {
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      fn(...args);
    }, wait);
  };
  debounced.cancel = () => {
    if (timer) clearTimeout(timer);
    timer = null;
  };
  return debounced;
}
